export default __webpack_public_path__ + "static/media/info-circle-red.ae5582ac.svg";